import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../../i18n";
import { services, LOGO_URL } from "../../data/services";
import { ArrowUpRight } from "lucide-react";

export const Footer = () => {
  const { lang } = useLang();
  const year = new Date().getFullYear();
  const cta = lang === "fr" ? ["Travaillons", "ensemble"] : ["Let's work", "together"];
  const cols = {
    fr: { s: "Services", c: "Entreprise", exp: "Expertise", real: "Réalisations", contact: "Contact", rights: "Tous droits réservés." },
    en: { s: "Services", c: "Company", exp: "Expertise", real: "Projects", contact: "Contact", rights: "All rights reserved." },
  }[lang];

  return (
    <footer className="bg-[#050505] pt-24 md:pt-32 pb-10 border-t border-white/10 overflow-hidden">
      <div className="w-full max-w-screen-2xl mx-auto px-6 md:px-12 lg:px-16">
        <Link to="/contact" data-testid="footer-cta" className="group block">
          <h2 className="font-display font-black tracking-tighter leading-[0.82] text-[16vw] lg:text-[13vw]">
            <span className="block">{cta[0]}</span>
            <span className="flex items-center gap-4 text-primary-c">
              {cta[1]}
              <ArrowUpRight className="w-[8vw] h-[8vw] group-hover:rotate-45 transition-transform duration-500" strokeWidth={1.2} />
            </span>
          </h2>
        </Link>

        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-10 border-t border-white/10 pt-12">
          <div className="col-span-2 md:col-span-1">
            <img src={LOGO_URL} alt="Fixedrone" className="h-8 w-auto" />
            <p className="text-white/40 text-sm mt-4 max-w-xs leading-relaxed">Smart Aircraft — {lang === "fr" ? "L'expertise vue du ciel." : "Expertise from the sky."}</p>
            <p className="text-white/40 text-sm mt-4 leading-relaxed">6D, Route de Trèves<br/>L-2633 Senningerberg, Luxembourg</p>
          </div>
          <div>
            <h4 className="font-mono-p text-xs uppercase tracking-widest text-white/40 mb-4">{cols.s}</h4>
            <ul className="space-y-2.5">
              {services.map((s) => (
                <li key={s.slug}><Link to={`/services/${s.slug}`} className="text-white/60 hover:text-primary-c text-sm transition-colors">{s[lang].name}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-mono-p text-xs uppercase tracking-widest text-white/40 mb-4">{cols.c}</h4>
            <ul className="space-y-2.5">
              <li><Link to="/expertise" className="text-white/60 hover:text-primary-c text-sm transition-colors">{cols.exp}</Link></li>
              <li><Link to="/realisations" className="text-white/60 hover:text-primary-c text-sm transition-colors">{cols.real}</Link></li>
              <li><Link to="/contact" className="text-white/60 hover:text-primary-c text-sm transition-colors">{cols.contact}</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-mono-p text-xs uppercase tracking-widest text-white/40 mb-4">{cols.contact}</h4>
            <ul className="space-y-2.5 text-sm text-white/60">
              <li><a href="tel:+33749850244" className="hover:text-primary-c transition-colors">+33 749 850 244</a></li>
              <li><a href="mailto:info@fixedrone.com" className="hover:text-primary-c transition-colors">info@fixedrone.com</a></li>
              <li className="text-white/40">Lun–Ven : 9h – 17h</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col sm:flex-row justify-between gap-3 text-white/30 font-mono-p text-xs border-t border-white/10 pt-8">
          <span>© {year} Fixedrone. {cols.rights}</span>
          <Link to="/admin" data-testid="footer-admin-link" className="hover:text-primary-c transition-colors">Admin</Link>
        </div>
      </div>
    </footer>
  );
};
